import {createAction, props} from '@ngrx/store';
import {SummaryCreateDTO, SummaryDocumentDTO, SummaryDTO} from '../../dto/summary';

// Project Summary Actions
export const loadProjectSummaries = createAction(
  '[Summary] Load Project Summaries',
  props<{ projectId: number }>()
);

export const loadProjectSummariesSuccess = createAction(
  '[Summary] Load Project Summaries Success',
  props<{ summaries: SummaryDTO[], projectId: number }>()
);

export const loadProjectSummariesFailure = createAction(
  '[Summary] Load Project Summaries Failure',
  props<{ error: any; notFound?: boolean, projectId: number }>()
);

export const loadProjectSummary = createAction(
  '[Summary] Load Project Summary',
  props<{ projectId: number, summaryId: number }>()
);

export const loadProjectSummarySuccess = createAction(
  '[Summary] Load Project Summary Success',
  props<{ summary: SummaryDTO, projectId: number }>()
);

export const loadProjectSummaryFailure = createAction(
  '[Summary] Load Project Summary Failure',
  props<{ error: any; notFound?: boolean, projectId: number }>()
);

export const generatePaperSummary = createAction(
  '[Summary] Generate Paper Summary',
  props<{ projectId: number, paperId: number }>()
);

export const generatePaperSummarySuccess = createAction(
  '[Summary] Generate Paper Summary Success',
  props<{ summary: SummaryDocumentDTO, paperId: number }>()
);

export const generatePaperSummaryFailure = createAction(
  '[Summary] Generate Paper Summary Failure',
  props<{ error: any, paperId: number }>()
);

export const generateProjectSummary = createAction(
  '[Summary] Generate Project Summary',
  props<{ projectId: number, summary: SummaryCreateDTO }>()
);

export const generateProjectSummarySuccess = createAction(
  '[Summary] Generate Project Summary Success',
  props<{ summary: SummaryDTO, projectId: number }>()
);

export const generateProjectSummaryFailure = createAction(
  '[Summary] Generate Project Summary Failure',
  props<{ error: any, projectId: number }>()
);

export const stopGenerateProjectSummary = createAction(
  '[Summary] Stop Generate Project Summary',
  props<{ projectId: number }>()
);

export const stopGenerateProjectSummarySuccess = createAction('[Summary] Stop Generate Project Summary Success');
export const stopGenerateProjectSummaryFailure = createAction(
  '[Summary] Stop Generate Project Summary Failure',
  props<{ error: string }>()
);

export const generateProjectSummaryNotRunning = createAction(
  '[Summary] Check Running Success/Fail &  Not Running'
);

export const generateProjectSummaryComplete = createAction(
  '[Summary] Stop Generate Project Summary Complete',
  props<{ projectId: number }>()
);

export const checkGenerateProjectSummaryStart = createAction(
  '[Summary] Check Running Start',
  props<{ projectId: number }>()
);


export const deleteSummary = createAction(
  '[Summary] Delete Summary',
  props<{ projectId: number, summaryId: number }>()
);

export const deleteSummarySuccess = createAction(
  '[Summary] Delete Summary Success',
  props<{ projectId: number, summaryId: number }>()
);

export const deleteSummaryFailure = createAction(
  '[Summary] Delete Summary Failure',
  props<{ error: any, projectId: number }>()
);

